<template>
  <div :class="classBar" class="bar">
    <div
      :class="classProgress"
      :style="styleProcess"
      class="barPrecent"
    ></div>
    <span v-if="showText" class="info">{{ text }}</span>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: "ProcessCustom",
  components: {},
  props: {
    text: {
      type: String,
      required: false,
      default: "",
    },
    classBar: {
      type: String,
      required: false,
      default: "progress",
    },
    classProgress: {
      type: String,
      required: false,
      default: "precent",
    },
    percent: {
      type: String,
      required: false,
      default: '0%',
    },
  },
  computed: {
    styleProcess() {
      return {
        width: this.percent,
      };
    },
    showText() {
      return this.text !== "" ? true : false
    }
  },
};
</script>

<style scoped lang="scss">
.bar {
  position: relative;
}
.barPrecent {
  position: absolute;
  top: 0;
  left: 0;
}
.progress {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: #333A64;;
}
.precent {
  width: 0;
  height: 100%;
  background: #3986EE;
}
.info {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  font-weight: normal;
  font-size: 12px;
  line-height: 1;
  width: 100%;
  text-align: center;
}
</style>
